<div class="maintenance-plan-container">
    <app-dropdown-autocomplete labelAlign="top"
                               [formControl]="planForm.controls.plan"
                               [items]="plans"
                               [resetSelectionOnItemChange]="false"
                               [appendTo]="'body'"
                               [label]="'admin.tools.form.labels.maintenancePlan.label' | translate"
                               [emptyText]="'admin.tools.form.labels.maintenancePlan.placeholder' | translate"
                               (selectItem)="onSelectPlan($event)"
                               valueField="id">
    </app-dropdown-autocomplete>
</div>
